import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getLaboratoryOptions } from '@/module/Laboratory';
import { LaboratoryEdit } from '@/module/Laboratory/LaboratoryEdit';

export const Route = createFileRoute(
  '/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/$labId/_layout/edit',
)({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { researchCenterId, labId } = Route.useParams();

  const { data: laboratory } = useSuspenseQuery(getLaboratoryOptions(labId));

  return (
    <LaboratoryEdit
      researchCenterId={researchCenterId}
      laboratory={laboratory}
    />
  );
}
